export default __webpack_public_path__ + "media/images/tenant/banner_1-7ad19bdbef1a9e47d54cb6a18eb6dff6.png";